"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Tick = function Tick(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 512 512'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0\r c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7\r C514.5,101.703,514.499,85.494,504.502,75.496z'
  })));
};
/* eslint-enable */
var _default = Tick;
exports["default"] = _default;